import React from 'react'

const StoreAnalytics = () => {
  return (
    <div>StoreAnalytics</div>
  )
}

export default StoreAnalytics